import React, { useEffect, useState } from "react";

import { t } from "../../utils/ResourceUtils";
import ErrorUI from "../error-page/ErrorUI";

const MicroFrontend = (props) => {
  const [errorInfo, seterrorInfo] = useState({
    hasError: false,
    errorMessage: "",
    errorStack: "",
  });

  let repeatCount = 0;
  let maxRepeatedCount = 10;

  const renderMicroFrontend = () => {
    const { name, window, history, host } = props;
    const handleRender = () => {
      window[`render${name}`](`${name}-container`, history);
    };

    const handleRepeatCountExceeded = () => {
      seterrorInfo({
        ...errorInfo,
        hasError: true,
        errorMessage: `Please verify host - ${host} and microservice name - ${name}`,
      });
    };

    const handleTimeout = () => {
      repeatCount++;
      renderMicroFrontend();
    };

    try {
      if (window[`render${name}`]) {
        handleRender();
      } else {
        if (repeatCount === maxRepeatedCount) {
          handleRepeatCountExceeded();
        } else {
          setTimeout(handleTimeout, 800);
        }
      }
    } catch (error) {
      seterrorInfo({
        ...errorInfo,
        hasError: true,
        errorMessage: `Please verify host - ${host} and microservice name - ${name}`,
        errorStack: error?.stack,
      });
    }
  };

  useEffect(() => {
    const { name, host, moduleId, document } = props;
    localStorage.setItem("moduleId", moduleId);
    const scriptId = `micro-frontend-script-${name}`;
    if (document.getElementById(scriptId)) {
      renderMicroFrontend();
      return;
    }
    fetch(`${host}/asset-manifest.json`)
      .then((res) => res.json())
      .then((manifest) => {
        const script = document.createElement("script");
        script.id = scriptId;
        script.crossOrigin = "";
        script.src = `${host}${manifest["files"]["main.js"]}`;
        script.onload = renderMicroFrontend;
        document.head.appendChild(script);
        const cssLink = document.createElement("link");
        cssLink.rel = "stylesheet";
        cssLink.href = `${host}${manifest["files"]["main.css"]}`;
        document.head.appendChild(cssLink);
      })
      .catch((error) => {
        seterrorInfo({
          ...errorInfo,
          hasError: true,
          errorMessage: `${t("cm.unable_verify_host")} - ${host}`,
          errorStack: error?.stack,
        });
      });
  }, []);

  return errorInfo.hasError === true ? (
    <ErrorUI errorMessage={errorInfo.errorMessage} errorStack={errorInfo.errorStack} />
  ) : (
    <main id={`${props.name}-container`} data-testId={`${props.name}-container`} />
  );
};

MicroFrontend.defaultProps = {
  document,
  window,
};

export default MicroFrontend;
